import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import SummaryField from 'components/common/SummaryField'
import Columns from 'components/common/Columns/Columns'
import Section from '../Section'
import {
  SERVICES_SELECTOR_TARGET_ID,
  DATE_TIME_SELECTOR_TARGET_ID,
  APPOINTMENT_SUMMARY_SELECTOR_TARGET_ID } from 'constant'
import { DEFAULT_TITLE, INNER_PROPS, noSelectionError } from './constants'

const BOTAppointmentSummary = ({
  title = DEFAULT_TITLE,
  selectedServices,
  selectedVehicle,
  selectedStore,
  selectedDateTime,
  isQuotePage,
  isOnlineAppointment,
  isSelectionValid,
  hasSubmitSucceeded,
  productPlaceholder,
  addVehicle,
  showStoreLocatorModalInAppointmentMode,
  handleTAOSDateTimeUpdate
}) =>
  <SummarySection
    id={ APPOINTMENT_SUMMARY_SELECTOR_TARGET_ID }
    title={ title }>
    <Summary>
      <CustomColumns
        width={ '100% 100%' }
        adaptive>
        <Fragment>
          <Field
            data-at-summary-vehicle-selector
            asset="car-red"
            medium
            info={ selectedVehicle }
            editDisabled={ isQuotePage }
            innerProps={ INNER_PROPS }
            link="Select Vehicle"
            title="I’d like to bring my"
            padding={ 80 }
            onClick={ addVehicle } />
          <Field
            data-at-summary-select-location
            asset="location-red"
            medium
            title="to"
            info={ selectedStore }
            link="Select Location"
            padding={ 80 }
            onClick={ () => showStoreLocatorModalInAppointmentMode(handleTAOSDateTimeUpdate) } />
        </Fragment>
        <Fragment>
          <Field
            data-at-summary-product
            asset="service-red"
            medium
            title="for"
            info={ selectedServices }
            targetId={ SERVICES_SELECTOR_TARGET_ID }
            isText={ !isOnlineAppointment }
            link={ productPlaceholder }
            padding={ 80 } />
          <Field
            data-at-summary-select-data
            asset="calendar-red"
            medium
            title="drop-off at"
            info={ selectedDateTime }
            targetId={ DATE_TIME_SELECTOR_TARGET_ID }
            link="Select Date & Time"
            padding={ 80 } />
        </Fragment>
      </CustomColumns>
    </Summary>

    <ErrorMessage
      role="alert"
      aria-live="assertive"
      aria-label={ noSelectionError }>
      { (hasSubmitSucceeded && !isSelectionValid && noSelectionError) || '' }
    </ErrorMessage>
  </SummarySection>

BOTAppointmentSummary.propTypes = {
  addVehicle: PropTypes.func,
  handleTAOSDateTimeUpdate: PropTypes.func,
  hasSubmitSucceeded: PropTypes.bool,
  isOnlineAppointment: PropTypes.bool,
  isQuotePage: PropTypes.bool,
  isSelectionValid: PropTypes.bool,
  productPlaceholder: PropTypes.string,
  selectedDateTime: PropTypes.string,
  selectedServices: PropTypes.string,
  selectedStore: PropTypes.string,
  selectedVehicle: PropTypes.string,
  showStoreLocatorModalInAppointmentMode: PropTypes.func,
  title: PropTypes.string
}

export default BOTAppointmentSummary

const Summary = styled.div`
  ${Media.desktop`
    margin: -5px -12px 0;
  `}
  ${Mixin.responsive('padding', '0 0 10px', '5px 0 25px')}
`

const Field = styled(SummaryField)`
  ${Mixin.responsive('margin', '0 12px 40px', '0 0 15px')}
`

const SummarySection = styled(Section)`
  border-bottom: unset;
  margin: 0;
  ${props => props.oneColumn && css`
    ${Media.mobile`
      margin: 0 16px;
    `}
  `}
`

const CustomColumns = styled(Columns)`
  table-layout: fixed;

  & > div {
    display: table;
    table-layout: fixed;
  }
`

const ErrorMessage = styled.div`
  color: red;
  text-align: right;
  padding-top: 20px;
`
